import { SagaGenerator, call, put, select } from 'typed-redux-saga'

import services from '@services'
import type { AuthenticationResponse } from '@services/getAuthenticationService'
import { ApplicationState } from '@store/types'
import { setLastServiceResponse } from '@store/session/actions'

import { setCpfAuthentication, setUserNameAuthentication } from '../actions'

export default function* getAuthenticationSaga(): SagaGenerator<void> {
  try {
    const { accessToken } = yield* select((state: ApplicationState) => state.session)
    const { data } = yield* call(services.getAuthenticationService, accessToken)
    yield* put(setLastServiceResponse({ code: 'OK', serviceName: 'getAuthenticationService' }))
    const auth = data as AuthenticationResponse
    const cpf = auth?.document || undefined
    const userName = auth?.name || undefined

    yield* put(setCpfAuthentication(cpf))
    yield* put(setUserNameAuthentication(userName))
  } catch (e) {
    yield* put(setLastServiceResponse({ code: 'ERROR', serviceName: 'getAuthenticationService' }))
  }
}
